import React from "react";
import PropTypes from "prop-types";

const AnalyticsSettings = ({ ga4MeasurementId, setGa4MeasurementId, t_controls }) => {
  return (
    <div className="md-form">
      <h5>{t_controls.ga4_settings}</h5>
      <input
        className="form-control validate"
        type="text"
        value={ga4MeasurementId}
        placeholder={t_controls.ga4_measurement_id_placeholder}
        onChange={(e) => setGa4MeasurementId(e.target.value)}
      />
      <small className="form-text text-muted">
        {t_controls.ga4_help_text}
      </small>
    </div>
  );
};

AnalyticsSettings.propTypes = {
  ga4MeasurementId: PropTypes.string.isRequired,
  setGa4MeasurementId: PropTypes.func.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default AnalyticsSettings;
